var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoNoneMembership16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.405 4H9.614c-.887 0-1.61.723-1.61 1.61v4.773c0 .886.723 1.61 1.61 1.61h4.776c.887 0 1.61-.724 1.61-1.61V5.602c0-.879-.716-1.594-1.602-1.594",
  fill: "#2E80FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.402 4.008H1.61C.723 4.008 0 4.73 0 5.618v4.773C0 11.277.723 12 1.61 12h4.784c.887 0 1.61-.723 1.61-1.61V5.61a1.6 1.6 0 0 0-1.602-1.602Z",
  fill: "#1A2E80"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.317 10.336a.52.52 0 1 1-1.041 0 .52.52 0 0 1 1.041 0Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.686 8.51a.571.571 0 0 0-.428.225c-.272.31-.63.56-1.104.56a1.301 1.301 0 0 1-1.307-1.291c0-.692.56-1.29 1.307-1.29.474 0 .832.24 1.104.559.086.109.257.225.428.225.311 0 .529-.233.529-.49a.545.545 0 0 0-.086-.303A2.33 2.33 0 0 0 4.161 5.68c-1.33 0-2.364 1.019-2.364 2.333 0 1.313 1.034 2.332 2.364 2.332.856 0 1.54-.397 1.968-1.019a.553.553 0 0 0 .086-.31c0-.257-.218-.49-.529-.49",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.317 10.336a.52.52 0 1 1-1.041 0 .52.52 0 0 1 1.041 0Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.002 5.664a.52.52 0 0 0-.521.52v3.608a.52.52 0 1 0 1.042 0V6.185a.52.52 0 0 0-.521-.521Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.335 7.988a.521.521 0 0 0-.52-.52h-3.618a.521.521 0 1 0 0 1.041h3.617a.521.521 0 0 0 .521-.52Z",
  fill: "#fff"
})));
export default SvgLogoNoneMembership16X16;